import { CsrdOnDemandAttributes } from '@upright/ui/common/upright/model/output/scores/csrd/csrd-company-double-materiality/types';
import { createContext, useContext, PropsWithChildren } from 'react';
import { CsrdCompanyProps } from '.';

export interface CsrdCompanyContextValue {
  companyId: string;
  companyName: string | undefined;
  onDemandAttrs?: CsrdOnDemandAttributes;
  shouldTrackPlgAppcuesEvents: boolean;
  shouldUseLatestPublicRelease: boolean;
  requiresSubscriptionForOperationalData: boolean;
}

const companyMaterialityContext = createContext<CsrdCompanyContextValue | undefined>(undefined);

export function useCsrdCompanyContext() {
  const context = useMaybeCsrdCompanyContext();
  if (context === undefined) {
    throw new Error('useCsrdCompanyContext must be used within a CsrdCompanyProvider');
  }
  return context;
}

export function useMaybeCsrdCompanyContext() {
  return useContext(companyMaterialityContext);
}

type CsrdCompanyProviderProps = PropsWithChildren<
  Pick<CsrdCompanyProps, 'companyId' | 'companyName' | 'onDemandAttrs'> & {
    shouldTrackPlgAppcuesEvents: boolean;
    shouldUseLatestPublicRelease: boolean;
    requiresSubscriptionForOperationalData: boolean;
  }
>;

export function CsrdCompanyProvider(props: CsrdCompanyProviderProps) {
  const { children, ...rest } = props;
  const contextValue: CsrdCompanyContextValue = rest;

  return <companyMaterialityContext.Provider value={contextValue}>{children}</companyMaterialityContext.Provider>;
}
